import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { APPCONFIG } from './config';
import { LayoutService } from './layout/layout.service';
import {TranslateService} from 'ng2-translate';

// 3rd
import 'styles/font-awesome.scss';
import 'styles/material2-theme.scss';
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';

@Component({
    selector: 'app-root',
    template: require('./app.component.html'),
    providers: [LayoutService],
})
export class AppComponent implements OnInit {
    public AppConfig: any;
    constructor(private router: Router,
                private translate: TranslateService) { 
                                     
                
                }

    private msg: string;            

    ngOnInit() {
        this.AppConfig = APPCONFIG;

        // Scroll to top on route change
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            document.body.scrollTop = 0;
        });
        
        this.translate.addLangs(["en", "pt-br"]);
        this.translate.setDefaultLang('pt-br');
        this.translate.use('pt-br');

        this.translate.get('SHIP').subscribe(
            (res:string) => { console.log(res)}
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.component.ts